var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbBadge',{attrs:{"text":_vm.payment,"type":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }